export const scrollToElementId = (elementId: string, compensationInPx = 0) => {
  document
    .getElementById(elementId)
    .scrollIntoView({ block: 'start' });
  const scrolledY = window.scrollY;
  if (scrolledY) {
    window.scroll(0, scrolledY - compensationInPx);
  }
};

export const smoothScrollToElementId = (elementId: string, durationInMilisecs: number, compensationInPx = 0) => {
  const target = document.getElementById(elementId);
  const targetPosition = target.getBoundingClientRect().top - compensationInPx;
  const startPosition = window.pageYOffset;
  let startTime = null;

  const animation = (currentTime: number) => {
    if (startTime === null) { startTime = currentTime; }
    const timeElapsed = currentTime - startTime;
    const run = quadraticEase(timeElapsed, startPosition, targetPosition, durationInMilisecs);
    window.scrollTo(0, run);
    if (timeElapsed < durationInMilisecs) { requestAnimationFrame(animation); }
  };

  const quadraticEase = (t: number, b: number, c: number, d: number) => {
    t /= d / 2;
    if (t < 1) { return c / 2 * t * t + b; }
    t--;
    return -c / 2 * (t * (t - 2) - 1) + b;
  };

  requestAnimationFrame(animation);
};

export const isValidHttpUrl = (supposedUrl: string) => {
  let url: URL;

  try {
    url = new URL(supposedUrl);
  } catch (_) {
    return false;
  }

  return url.protocol === 'http:' ||
    url.protocol === 'https:';
};
